"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var namespacedKeyMirror = function namespacedKeyMirror(obj, namespace) {
  var result = {};

  if (!(obj instanceof Object) || Array.isArray(obj)) {
    throw new Error('namespacedKeyMirror expected the first argument to be an object');
  }

  if (!(namespace instanceof String || typeof namespace === 'string') || namespace.length === 0) {
    throw new Error('namespacedKeyMirror expected the namespace to be a non-zero lengthed string');
  }

  var key;

  for (key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = namespace + "/" + key;
    }
  }

  return result;
};

var _default = namespacedKeyMirror;
exports.default = _default;
module.exports = exports.default;